import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";

export const AGENT_EVENT = "landin-agent-updated";

export function useAgent() {
  const navigate = useNavigate();
  const [agent, setAgent] = useState(null);
  const load = useCallback(() => {
    api.get("/auth/me").then((r) => setAgent(r.data)).catch((err) => {
      if (err?.response?.status === 401) {
        setToken(null);
        navigate("/login", { replace: true });
      }
    });
  }, [navigate]);
  useEffect(() => {
    load();
    window.addEventListener(AGENT_EVENT, load);
    return () => window.removeEventListener(AGENT_EVENT, load);
  }, [load]);
  return agent;
}
